import {Link} from 'react-router-dom';
import clsx from 'clsx';
import {KTSVG, toAbsoluteUrl} from '../../../helpers';
import {useLayout} from '../../core';
import {useGetMe} from '../../../../app/hooks/useGetMe';

const SidebarLogo = () => {
    const {config} = useLayout();
    const appSidebarDefaultMinimizeDesktopEnabled =
        config?.app?.sidebar?.default?.minimize?.desktop?.enabled;
    const appSidebarDefaultCollapseDesktopEnabled =
        config?.app?.sidebar?.default?.collapse?.desktop?.enabled;
    const toggleType = appSidebarDefaultCollapseDesktopEnabled
        ? 'collapse'
        : appSidebarDefaultMinimizeDesktopEnabled
        ? 'minimize'
        : '';
    const toggleState = appSidebarDefaultMinimizeDesktopEnabled ? 'active' : '';
    const appSidebarDefaultMinimizeDefault =
        config.app?.sidebar?.default?.minimize?.desktop?.default;

    const UserConfig = useGetMe();

    const LogosLink = {
        magic:"/media/logos/logo-magic.png" ,
        celeste:"/media/logos/LOGO_CELESTE_Sans_Baseline_Blanc.png" ,
        icow:"/media/logos/logo-icow.png" ,
        phpnet:"/media/logos/logo-phpnet.png" ,
        nuxit:"/media/logos/logo-nuxit.png" 
    };
    
    let SelectedLogo:string  = LogosLink.celeste;

    switch (UserConfig?.system) {
        case "magic":
            SelectedLogo = LogosLink.magic;
            break;
        case 'icow':
            SelectedLogo = LogosLink.icow;
            break;
        case 'phpnet':
            SelectedLogo = LogosLink.phpnet;
            break;
        case 'nuxit':
            SelectedLogo = LogosLink.nuxit;
            break;
        default:
            SelectedLogo = LogosLink.celeste;
            break;
    }

    return (
        <div className="app-sidebar-logo px-6 pt-3 mb-3" id="kt_app_sidebar_logo">
            <Link to="/dashboard">
                {config.layoutType === 'dark-sidebar' ? (
                    <img
                        alt="Logo"
                        src={toAbsoluteUrl(SelectedLogo)}
                        className="h-45px app-sidebar-logo-default"
                    />
                ) : (
                    <>
                        <img
                            alt="Logo"
                            src={toAbsoluteUrl(SelectedLogo)}
                            className="h-35px app-sidebar-logo-default theme-light-show"
                        />
                        <img
                            alt="Logo"
                            src={toAbsoluteUrl(SelectedLogo)}
                            className="h-35px app-sidebar-logo-default theme-dark-show"
                        />
                    </>
                )}

                <img
                    alt="Logo"
                    src={toAbsoluteUrl('/media/logos/logo_etoile_celeste.png')}
                    className="h-20px app-sidebar-logo-minimize"
                />
            </Link>

            {(appSidebarDefaultMinimizeDesktopEnabled ||
                appSidebarDefaultCollapseDesktopEnabled) && (
                <div
                    id="kt_app_sidebar_toggle"
                    className={clsx(
                        'app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary body-bg h-30px w-30px position-absolute top-50 start-100 translate-middle rotate',
                        {active: appSidebarDefaultMinimizeDefault}
                    )}
                    data-kt-toggle="true"
                    data-kt-toggle-state={toggleState}
                    data-kt-toggle-target="body"
                    data-kt-toggle-name={`app-sidebar-${toggleType}`}
                >
                    <KTSVG
                        path="/media/icons/duotune/arrows/arr079.svg"
                        className="svg-icon-2 rotate-180"
                    />
                </div>
            )}
        </div>
    );
};

export {SidebarLogo};
